import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {SafeStyle} from '@angular/platform-browser';

@Component({
  selector: 'awair-device-marker',
  templateUrl: './device-marker.component.html',
  styleUrls: ['./device-marker.component.scss']
})

export class DeviceMarkerComponent implements OnInit {

  @HostBinding('style.top') hostTop: string | SafeStyle = '0px';
  @HostBinding('style.left') hostLeft: string | SafeStyle = '0px';

  @Input() name: string;
  @Input() value: string;
  @Input() unit: string;
  @Input() color: string = '#64C2E6';
  @Input() deviceUuid: string;
  @Input() isOnline: boolean;
  @Input() isSelected: boolean = false;

  @Output() clickDevice: EventEmitter<{ deviceUuid: string, isSelected: boolean }> =
    new EventEmitter<{ deviceUuid: string, isSelected: boolean }>();

  constructor() {
  }

  ngOnInit() {
  }

  onClickIcon(deviceUuid: string): void {
    this.isSelected = !this.isSelected;
    this.clickDevice.emit({deviceUuid, isSelected: this.isSelected});
  }
}
